import { t } from "i18next";
import React, { useState } from "react";
import Modal from "../../Modal/modal";

const ActionButtons = ({ editState, text, btntext = 'properties.detail', isSimpleTable }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    return (
        <>
            <div className="col full-width-height w-100 btn-primary-custom">
                <button onClick={handleOpenModal} className="btn btn-primary">{t(btntext)}</button>
            </div>
            <Modal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                data={editState}
                text={text}
                isSimpleTable={isSimpleTable}
            />
        </>
    );
};

export default React.memo(ActionButtons);
